import { useEffect, useState } from "react";
import { IOpenPanel } from "../../../../Interfaces/IPanel";
import { IResponseApiFluent, codigosRespuesta } from "../../../../Interfaces/base/IResponse";
import { IEquipoSync, IPostEquipo } from "../../../../Interfaces/estadoEquipos/IEstadoEquipo";
import { IntegracionService } from "../../../../services/auxiliar/IntegracionService";

export const UsePanelEquipoSync=(props:IOpenPanel)=>{
    const [LoadingSincronizar,setLoadingSincronizar]=useState<boolean>(false)
    const [status, setStatus] = useState<codigosRespuesta>(0);
    const [mensaje, setMensaje] = useState<string>("");
    const [loading,setLoading]=useState<boolean>(false)
    const [equiposSync,setEquiposSync]=useState<IEquipoSync[]>([])
    const reset=()=>{
        setMensaje("")
        setStatus(0)
        props.onDismiss()
    }
    const getEquipos=()=>{
        setLoadingSincronizar(true)
        IntegracionService.GetEquipos().then((res)=>{
            if(res.status==200){
             setLoadingSincronizar(false)
             setEquiposSync(res.data)
            }
         }).catch((e)=>{
             setLoadingSincronizar(false)
         })
    }
    useEffect(()=>{
        if(props.isOpen){
            getEquipos()
        }
    },[props.isOpen])
    const SyncronizarEquipo=()=>{
        setLoading(true)
        const request:IPostEquipo={
            equipos: equiposSync
        }
        IntegracionService.PostEquipo(request).then((res)=>{
            if(res.status==200){
                setStatus(200)
                setMensaje(res.data.mensaje);
                setTimeout(() => {
                    props.reload?.();
                    reset()
                }, 3000)
            }else{
                setStatus(500)
            }
            setLoading(false)
        }).catch((e)=>{
            if (
                e.response?.data &&
                'type' in e.response.data &&
                'title' in e.response.data &&
                'status' in e.response.data &&
                'instance' in e.response.data &&
                'errors' in e.response.data
              ) {
                const errorResponse = e.response.data as IResponseApiFluent;
                const mensajeError = errorResponse.errors.join('\n');
                setMensaje(mensajeError);
              } else {
                console.log('Error detallado:', e);
                setMensaje("Error Inesperado");
              }
              setStatus(500);
              setLoading(false);
        })
    }
    return {status,loading,mensaje,SyncronizarEquipo,reset,LoadingSincronizar,equiposSync}

}